<template>
    <a class="btn-email" target="_blank" :href="link" v-if="link">
        <slot> </slot>
    </a>
</template>
<script>
export default {
    name: "btn-email",
    props: {
        email: String,
        text: String,
    },
    computed: {
        link() {
            let text = "mailto:" + this.email;
            if (this.text) {
                text += "?body=" + encodeURIComponent(this.text);
            }
            return text;
        },
    },
};
</script>
